import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "input", "preview", "companyName" ];

  connect() {
    this.updatePreview();
  }

  updatePreview() {
    const value = this.inputTarget.value || "";
    const slug = this.parameterize(value);
    // Remove dashes to match url_identifier format
    const cleanSlug = slug.replace(/-/g, "");
    // Show prefix_id format if too long (>= 24 chars)
    const displaySlug = cleanSlug.length < 24 && cleanSlug.length > 0 
      ? cleanSlug 
      : "org_XXX";
    this.previewTarget.textContent = displaySlug;
    
    // Update company name in the employee question
    if (this.hasCompanyNameTarget) {
      this.companyNameTarget.textContent = value || "your company";
    }
  }

  // Mimics Rails' parameterize method
  parameterize(str) {
    if (!str) return "";
    
    return str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "") // Remove special characters except spaces and hyphens
      .replace(/\s+/g, "-")      // Replace spaces with hyphens
      .replace(/-+/g, "-")       // Replace multiple hyphens with single hyphen
      .replace(/^-+|-+$/g, "");   // Remove leading/trailing hyphens
  }
}

